import { Box } from '@mui/material';
import ErpJobTitlesTab from '../configuration/ErpJobTitlesTab';

/**
 * Cargos como sección propia del modo ERP (antes vivía como tab de
 * Configuración). El CRUD sigue en ErpJobTitlesTab; esta página lo monta
 * standalone. Configuración vuelve en fase 2 con los parámetros de cálculo.
 */
const ErpJobTitlesLayout = () => (
  <Box sx={{ p: 3 }}>
    <ErpJobTitlesTab />
  </Box>
);

export default ErpJobTitlesLayout;
